import React from "react"
import {Action} from "@reduxjs/toolkit"
import {useDispatch} from "react-redux"
import {formatTextTestIds} from "@next/utils"
import {ThunkDispatch} from "redux-thunk"
import {setPrimaryNavIndex} from "../../../../ducks/primary-nav"
import {getSecondaryNavDataThunk, setIsInSecondaryMeganav} from "../../../../ducks/secondary-nav"
import {Container, Title} from "./component"
import {IconContainer} from "../../../CatalogueItem/component"
import NavIcon from "../../../NavIcon"
import {PrimaryNavItem} from "../../../../models/primary-nav"
import {NAV_BAR, LTR} from "../../../../config/constants"
import urls from "../../../../config/urls"
import State from "../../../../ducks/state"

type BurgerPrimaryItemLinkProps = PrimaryNavItem & {
    itemKey: string
    siteUrl: string
    target: string
    index: number
    textAlignment: string
    chevronIconAltText: string
    realm: string
    variant: string
    iconsVersionPath: string
}
export const BurgerPrimaryItemLink = ({
    itemKey,
    index,
    title,
    linkColour,
    fontWeight,
    textAlignment,
    path,
    chevronIconAltText,
    realm,
    variant,
    iconsVersionPath,
}: BurgerPrimaryItemLinkProps) => {
    const linkProps = {
        "data-ga-v1": NAV_BAR,
        "data-ga-v2": title,
    }

    const dispatch = useDispatch<ThunkDispatch<State, null, Action<string>>>()
    const handleClick = () => {
        dispatch(setPrimaryNavIndex(index, title))
        if (index > -1)
            dispatch(getSecondaryNavDataThunk(path)).catch(error => {
                throw error
            })
        dispatch(setIsInSecondaryMeganav(true))
    }

    return (
        <Container
            key={itemKey}
            onClick={handleClick}
            data-testid={formatTextTestIds(`header-burger-menu-primary-item-${path}`)}
            tabIndex={0}
        >
            <Title fontWeight={fontWeight} linkColour={linkColour} {...linkProps} id={`burger-primary-link-${index}`}>
                {title}
            </Title>
            <IconContainer>
                <NavIcon
                    imageUrl={urls.burgerMenu.chevronUrl(realm, variant, iconsVersionPath)}
                    altText={chevronIconAltText}
                    width={1.5}
                    rotationDegrees={textAlignment === LTR ? -90 : 90}
                />
            </IconContainer>
        </Container>
    )
}

export default BurgerPrimaryItemLink
